import { GraduationCap } from 'lucide-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoginForm } from '@/components/auth/LoginForm'
import { useAuth } from '@/lib/auth'

export default function LoginPage() {
  const navigate = useNavigate()
  const { user, isAuthenticated } = useAuth()

  useEffect(() => {
    if (isAuthenticated && user) {
      if (user.tenantSlug) {
        navigate(`/${user.tenantSlug}/dashboard`, { replace: true })
      } else {
        navigate('/admin/tenants', { replace: true })
      }
    }
  }, [isAuthenticated, user, navigate])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50">
      <div className="mb-8 flex items-center space-x-2">
        <GraduationCap className="h-12 w-12 text-emerald-600" />
        <h1 className="text-3xl font-bold">JBCCHD 受講管理システム</h1>
      </div>
      <LoginForm
        onSuccess={() => {
          // Auth state change triggers useEffect above
        }}
      />
      <p className="mt-4 text-sm text-muted-foreground">管理者専用ログイン</p>
    </div>
  )
}
